export default __webpack_public_path__ + "static/media/cm-gold.335e61ce.png";